import { invert as _invert } from 'lodash-es';

import type { Invert } from './types';

/** Typed lodash invert. Inverts object keys and values */
export const invert = <T extends Record<string, string>>(obj: T): Invert<T> => {
  return _invert(obj) as Invert<T>;
};
